enum ReferenceDataKey {
    Warehouse = 'Warehouse',
    Country = 'Country',
    Account = 'Account',
    Locale = 'Locale',
    OrderStatus = 'OrderStatus',
    Channel = 'Channel',
    DueCountry = 'DueCountry',
    OrderQueues = 'OrderQueues',
    DUESyncError = 'DUESyncError',
    PaymentStatus = 'PaymentStatus',
    ChannelType = 'ChannelType',
    DocumentType = 'DocumentType',
    ERPVendorCodes = 'ERPVendorCodes',
}

export default ReferenceDataKey;